import React, { useState, useEffect } from 'react'
import { Box, TextInput,  Select, NumberInput, Flex, Group, Button, Text } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { addAdditionalLogistic, updateAdditionalLogistic } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'
import { validation } from '../../../../../plugins/validation'
import { additionalChargeType } from '../../../../../helper/master-unit'

const defaultVal = {
  name: '',
  amount: 0,
  charge_label: 'ORIGIN_CHARGE'
}

const formValidation = {
  name: {
    isError: false,
    message: ''
  },
  amount: {
    isError: false,
    message: ''
  },
  charge_label: {
    isError: false,
    message: ''
  },
}

const FormAdjustAdditionalLogistic = ({ dataLogistic, additionalChargeId, onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitAdditionalLogistic = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    const validateForm = {
      name: form.name,
      amount: `${form.amount}`,
      charge_label: form.charge_label
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      notificationError('Submit Additional Logistic Error', 'Check recheck your form')
      return
    }
    const payload = {
      name: form.name,
      amount: form.amount,
      charge_label: form.charge_label
    }
    if (dataLogistic !== null) {
      methodFunction = updateAdditionalLogistic(orderId, additionalChargeId, form.id, payload)
      titleMessageSuccess = 'Update Additional Logistic Successfully'
      captionMessageSuccess = 'You have been updated data additional logistic'
      titleMessageError = 'Update Additional Logistic Error'
    } else {
      methodFunction = addAdditionalLogistic(orderId, additionalChargeId, payload)
      titleMessageSuccess = 'Add Additional Logistic Successfully'
      captionMessageSuccess = 'You have been added new additional logistic'
      titleMessageError = 'Add Additional Logistic Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataLogistic) {
      handleSetForm(dataLogistic)
    }
    // eslint-disable-next-line
  }, [dataLogistic])

  const handleSetForm = (value) => {
    console.log(value)
    const dataDetail = {
      id: value.id,
      name: value.name,
      amount: value.grandTotal,
      charge_label: value.chargeLabel.toUpperCase()
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }
  return (
    <Box>
      <Box mb='md'>
        <TextInput
          name='name'
          value={formData.name}
          label='Name'
          placeholder='Input Name'
          onChange={(val) => handleChangeForm('name', val.target.value)}
          error={validationForm.name.isError ? `${validationForm.name.message}` : ''}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <NumberInput
          name='amount'
          label="Amount"
          value={formData.amount}
          leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
          placeholder='Input amount'
          onChange={(val) => handleChangeForm('amount', val)}
          error={validationForm.amount.isError ? `${validationForm.amount.message}` : ''}
          size='xs'
          withAsterisk
          thousandSeparator=","
          leftSectionWidth={40}
        />
      </Box>
      <Box mb='md'>
        <Select
          name='charge_label'
          value={formData.charge_label}
          label='Group'
          placeholder='Select Group'
          data={additionalChargeType}
          onChange={(val) => handleChangeForm('charge_label', val)}
          error={validationForm.charge_label.isError ? `${validationForm.charge_label.message}` : ''}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitAdditionalLogistic(formData)}>{dataLogistic ? 'Update' : 'Add'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustAdditionalLogistic